function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.3333 8.5H45.3333V21.25H22.6667V8.5H5.66667C2.53819 8.5 0 11.3555 0 14.875V61.625C0 65.1445 2.53819 68 5.66667 68H62.3333C65.4618 68 68 65.1445 68 61.625V14.875C68 11.3555 65.4618 8.5 62.3333 8.5ZM34 29.75C38.1674 29.75 41.5556 33.5617 41.5556 38.25C41.5556 42.9383 38.1674 46.75 34 46.75C29.8326 46.75 26.4444 42.9383 26.4444 38.25C26.4444 33.5617 29.8326 29.75 34 29.75ZM45.0146 59.5H22.9854C21.7576 59.5 20.766 58.1719 21.1437 56.8703C22.1236 53.4703 24.9687 51 28.3333 51H29.3014C30.7535 51.6773 32.3354 52.0625 34 52.0625C35.6646 52.0625 37.2583 51.6773 38.6986 51H39.6667C43.0194 51 45.8646 53.457 46.8562 56.8703C47.234 58.1719 46.2424 59.5 45.0146 59.5ZM41.5556 4.25C41.5556 1.89922 39.8674 0 37.7778 0H30.2222C28.1326 0 26.4444 1.89922 26.4444 4.25V17H41.5556V4.25Z",
  fill: "url(#paint0_linear_105_22)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_105_22",
  x1: -1.2666e-7,
  y1: 34,
  x2: 68,
  y2: 34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})));

var SvgFaSolidIdCardAlt = function SvgFaSolidIdCardAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaSolidIdCardAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fa-solid_id-card-alt.3c15c581.svg";
export { ForwardRef as ReactComponent };